
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/mobileBlockReparenting/components/StripedArea.scss.css.virtualfile';
        module.exports = {"stripedArea":"_stripedArea_b3ri4_1","stripeSvgRect":"_stripeSvgRect_b3ri4_3"};